/* jshint esversion: 6, -W097, -W040 */
/* globals module */
'use strict';

/**
 * Creates reamaze FAQ (knowledge base) section or contact us lightbox
 *
 * Usage example:
 * <reamaze-widget
 *   data-account="enervee"
 *   data-widget-type="kb">
 * </reamaze-widget>
 *
 * @module enervee_utils.common
 */
function reamazeWidget() {

    return {
        scope: {
            account: '@',
            brand: '@',
            widgetType: '@',
            isLightbox: '@?',
        },
        template: "<div ng-if='!vm.isLightbox' data-reamaze-embed='{{ vm.widgetType }}'></div>",
        bindToController: true,
        controllerAs: 'vm',
        controller: reamazeWidgetController
    };
}

reamazeWidgetController.$inject = ['$scope', '$window', '$timeout'];
function reamazeWidgetController($scope, $window, $timeout) {
    const REAMAZE_SCRIPT_PATH = 'https://cdn.reamaze.com/assets/reamaze.js';

    this.$onInit = function () {
        var defaultSupportVar = {
            ui: {
                anonymousMode: 'anonymous',
                enableKb: 'true',
            },
            user: {},
        };
        this.widgetType = this.widgetType || 'kb';
        $window._support = $window._support || defaultSupportVar;
        $window._support.account = this.account || 'enervee';
        $window._support.brand = this.brand || '3118';
        $window._support.ui.anonymousMode = 'anonymous';
        $window._support.ui.enableKb = 'true';

        if ($window.Reamaze) {
            $window.Reamaze.reload();
        } else {
            $window.$.getScript(REAMAZE_SCRIPT_PATH);
        }
    };
}

module.exports = reamazeWidget;